<template>
  <div :class="['lead-form', editable ? 'editable': '']">
    <h2 v-html="$t(content.title, 'title', 'signup')"></h2>
    <div class="copy">
      <div v-html='$t(content.text, "text", "signup")'></div>
    </div>
    <form action='#' autocomplete='off' @submit.prevent='false' class="form">
      <Field :key='field.name' :name='field.name' @validityChange='onValidityChange($event)' :label='$t(field.label, `fields.${field.name}`, "signup")' v-for='field, i in localFields' :value='form[field.name]' @change='updateField(field.name, $event)' :field='field' :validate-with='field.validate'></Field>
      <div class="field-component checkbox">
        <label for="subscribed">
          <input type='checkbox' name='subscribed' v-model='form.subscribed' :value='true'/>
          <span ref='tandcs' class='tandcs' v-html='$t(content.privacyLink, "privacy", "signup")'></span>
          <p class='error' v-if='signupAttempted && !validity.subscribed'>{{$t("Please accept the terms and conditions", "errors.tandcs", "signup")}}</p>
        </label>
      </div>
      <div class="actions">
        <a :disabled='!isValid' @click.prevent='signup' :style='buttonStyle' class='button'>{{ $t(content.buttonText, "buttonText", "signup")}}</a>
      </div>
    </form>

  </div>
</template>
<script>
import ContentEditable from '../../ContentEditable'
import TranslationMixin from '../lib/TranslationMixin'
import Field from '../../Field'
export default {
  props: {
    config: {type: Object, default: ()=>{{}}},
    editable: {type: Boolean, default: false},
    closable: {type: Boolean, default: true}
  },
  mixins: [TranslationMixin],
  inject: ['globalTheme'],
  components: {
    ContentEditable,
    Field
  },
  computed: {
    forceSignupField () {
      return {
        type: 'radio',
        label: 'Require sign up to view report?',
        options: [
          {label: 'Yes', value: true},
          {label: 'No', value: false}
        ]
      }
    },
    isValid () {
      let valid = true
      for (let field in this.validity){
        if (this.validity[field] !== true) {
          valid = false
        }
      }
      return valid
    },
    buttonStyle () {
      let borderRadius = (this.globalTheme.borderRadius || '500') + 'px'
      let style = {borderRadius: borderRadius, color: this.config.buttonTextColor, backgroundColor: this.config.buttonColor}
      return style
    }
  },
  data () {
    return {
      localFields: {},
      signupAttempted: false,
      validity: {},
      content: {},
      ready: false,
      form: {},
      default_fields: [
        {autocomplete: 'first_name-au', label: 'First name', name: 'first_name', type: 'text', validate: {string:[2,100]}},
        {autocomplete: 'last_name-au', label: 'Last name', name: 'last_name', type: 'text', validate: {string:[2,100]}},
        {autocomplete: 'email-au', label: 'Email', name: 'email', type: 'text', validate: {string:[2,100], regex: [/@/, "Must be a valid email address"]}},
        {autocomplete: 'company-au', label: 'Company', name: 'company', type: 'text', validate: {string:[2,100]}},
        {label: 'Job title', name: 'job_title', type: 'text', validate: {string:[2,100]}},
        {autocomplete: 'tel_no-au', label: 'Contact number', name: 'tel_no', type: 'text', validate: {string:[2,50]}}
      ]
    }
  },
  methods: {
    onValidityChange (event) {
      this.validity[event.name] = event.valid
    },
    signup () {
      this.signupAttempted = true
      if (!this.isValid) {
        return
      }
      this.$emit('signup', {lead: this.form})
    },
    close () {
      this.$emit('close')
    },
    updateSetting (setting, event) {
      this.content[setting] = event.value
    },
    updateField (index, event) {
      this.form[index] = event.value
    }
  },
  created () {
    this.content = this.config
    this.localFields = !_.isUndefined(this.config.fields) && this.config.fields.length > 0 ? this.config.fields : this.default_fields
    let validationFields = {}
    let formFields = {}
    for (let field of this.localFields) {
      validationFields[field.name] = false
      formFields[field.name]  = null
    }
    validationFields.subscribed = false
    formFields.subscribed = false
    this.validity = validationFields
    this.form = formFields
    this.save = _.debounce(function(content){
        this.$store.dispatch('saveSignup', content)
      }, 500)
  },
  mounted () {
    let privacyText = this.$refs.tandcs
    if (privacyText) {
      let links = privacyText.querySelectorAll('a')
      for (let link of links) {
        link.target = '_blank'
      }
    }
  },
  watch: {
    form: {
      deep: true,
      handler: function(newValue) {
        this.validity.subscribed = this.form.subscribed
      }
    }
  }
}
</script>
<style lang='scss'>
  .simple-form .lead-form .arrow-left {
    display: none;
  }
</style>
<style lang='scss' scoped>
@import '../../../../scss/components/variables';
@import '../../../../scss/components/form';
  .lead-form {
    padding: 2rem;
    position: relative;
    .show-fields {
      margin-top: 1rem;
    }
    .field-component + .field-component {
      margin-top:1rem;
    }
    ::v-deep .field-component {
      &.radio,&.checkbox {
        label {
          margin-bottom: 0.5rem;
        }
      }
      &.checkbox {

      }
    }
    .copy {
      margin-bottom: 1rem;
    }
    span.tandcs {
      display: inline-block;
      div {
        display: inline;
      }
    }
    .privacy {
      margin-top: 1rem;
    }
  }
  ::v-deep .lead-form h2 {
    margin-bottom: 0.5rem;
  }

  ::v-deep .field-errors {
    color: red;
    font-size: 90%;
    li {
      margin-top: 5px;
    }
    .arrow-left {
      display: none;
    }
  }

  .close {
    position: absolute;
    top:10px;
    right: 10px;
  }
  p.error {
    color: red;
    margin-top: 5px;
  }
  .button {
    width: auto;
    display: inline-block;
    background-color: #fbd147;
    color: black;
    border: none;
    font-weight: bold;
    min-width: 110px;
    border-radius: 500px;
    padding: 10px 3rem;
    cursor: pointer;
    border: 1px solid transparent;
    font-size: 120%;
    &[disabled] {
      cursor: not-allowed;
      border: 1px solid #ccc;
      color: #ccc;
      background-color: transparent;
      &:hover {
      background-color: transparent;
      }
    }
    &:hover {
      background-color: darken(#fbd147, 15%);
    }
  }
</style>